import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CsvImportFlow from '../common/CsvImportFlow';

/**
 * Modal component for importing deals from CSV
 */
const DealsImportModal = ({ isOpen, onClose, onImportComplete }) => {
  const [importResults, setImportResults] = useState(null);

  // Handle the import completion
  const handleImportComplete = (results) => {
    setImportResults(results);
    
    // If the caller provided a completion callback, call it with the results
    if (onImportComplete) {
      onImportComplete(results);
    }
    
    // If this is the final completion (user clicked "Done"), close the modal
    if (results.isComplete) {
      onClose();
      setImportResults(null);
    }
  };

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex justify-center items-center"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          // Only close if clicking outside, and not during active import
          if (!importResults || !importResults.loading) {
            onClose();
          }
        }
      }}
      tabIndex="0"
    >
      <div 
        className="relative bg-white rounded-lg shadow-xl max-w-4xl w-full mx-4 md:mx-0 p-6"
        onClick={e => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-medium text-gray-900">Import Deals from CSV</h3>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500 focus:outline-none"
            disabled={importResults && importResults.loading}
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <div className="mb-6">
          <CsvImportFlow 
            entityType="deals"
            onImportComplete={handleImportComplete}
            customFieldMappings={{
              'close_date': { label: 'Close Date', required: false, description: 'Expected close date (YYYY-MM-DD)' },
              'owner': { label: 'Deal Owner', required: false, description: 'Name or email of deal owner' }
            }}
          />
        </div>
      </div>
    </div>
  );
};

DealsImportModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onImportComplete: PropTypes.func
};

export default DealsImportModal;